module.exports = new __parcel__URL__("third-place.61f49419.svg").toString();